<template>
	<Navbar :breadcrumb="conferenceStore.selected.conference_name" />
	<header class="daynav">
		<div class="container-fluid">
			<button
				class="btn btn-drawer"
				id="BtnDrawerTeachers"
				:class="{ active: drawerTeachers }"
				@click="drawerTrigger('teachers')"
				type="button"
				aria-controls="drawerTeachers"
				data-cy="parent-teachers-modal-btn"
			>
				<IconTeacherDrawer />
				<span>{{ $t("message.Matrix.teachers") }}</span>
			</button>

			<Daynav :days="conferenceStore.selected.conference_days" />

			<button
				class="btn btn-drawer"
				id="BtnDrawerAgenda"
				:class="{ active: drawerAgenda }"
				@click="drawerTrigger('agenda')"
				type="button"
				aria-controls="drawerFinalize"
			>
				<div class="hstack">
					<IconAgendaDrawer />
					<span class="counter" v-if="agendaItems() > 0">{{ agendaItems() }}</span>
				</div>
				<span>{{ $t("message.Matrix.agenda") }}</span>
			</button>
		</div>
	</header>

	<main>
		<DrawerTeachers v-model="drawerTeachers" />
		<DrawerAgenda v-model="drawerAgenda" />

		<ScheduleMatrix @toggle-drawer="drawerTrigger" />
	</main>
</template>

<script setup>
import { ref } from "vue";
import IconTeacherDrawer from "@/assets/icons/teachershow.svg";
import IconAgendaDrawer from "@/assets/icons/agenda.svg";
import Navbar from "@/components/parent/Navbar.vue";
import Daynav from "@/components/parent/Daynav.vue";
import DrawerTeachers from "@/components/parent/DrawerTeachers.vue";
import DrawerAgenda from "@/components/parent/DrawerAgenda.vue";
import ScheduleMatrix from "@/components/parent/ScheduleMatrix.vue";
// import Teachers from "@/components/parent/Teachers.vue"
// import TeachersFooter from "./TeachersFooter.vue";
import { useMatrixStore } from "@/stores/parent/matrix";
import { useConferenceStore } from "@/stores/parent/conference";
import { useAgendaStore } from "@/stores/parent/agenda";
const agendaStore = useAgendaStore();

useMatrixStore();
const conferenceStore = useConferenceStore();
const drawerTeachers = ref(false);
const drawerAgenda = ref(false);

function agendaItems() {
	// return agendaStore.agenda.filter(meeting => meeting.conference_id == conferenceStore.selected.conference_id).length;
	return agendaStore.agenda.filter(
		(meeting) => meeting.conference_id == conferenceStore.selected.conference_id
	).length;
}
function drawerTrigger(target) {
	if (target === "teachers") {
		drawerTeachers.value = drawerTeachers.value === false ? true : false;
		drawerAgenda.value = false;
	} else if (target === "agenda") {
		drawerAgenda.value = drawerAgenda.value === false ? true : false;
		drawerTeachers.value = false;
	} else {
		drawerAgenda.value, (drawerTeachers.value = false);
	}
}
</script>
